import angular from 'angular';

import AddProducts from './addProducts';
import Documents from './documents';
import ESign from './ESign';
import GetSignaturesModal from './getClosingSignaturesModal';
import MakeChangesModal from './makeChangesModal';
import PaymentInstructions from './paymentInstructions';
import PipelineStageIndicator from './pipelineStageIndicator';
import ProjectDetails from './projectDetails';
import ProjectHistory from './projectHistory';
import ProjectInformation from './projectInformation';
import Walkthrough from './walkthrough';

import AppDetailController from './appDetailController';
import FundingRequestClosingFactory from './fundingRequestClosingFactory';
import FundingRequestDisbursementsFactory from './fundingRequestDisbursementsFactory';
import FundingRequestDocumentsFactory from './fundingRequestDocumentsFactory';
import FundingRequestInformationFactory from './fundingRequestInformationFactory';

export default angular.module('app.appDetail', [
    AddProducts,
    Documents,
    ESign,
    GetSignaturesModal,
    MakeChangesModal,
    PaymentInstructions,
    PipelineStageIndicator,
    ProjectDetails,
    ProjectHistory,
    ProjectInformation,
    Walkthrough,
])
    .controller('AppDetailController', AppDetailController)
    .factory('FRClosingFactory', FundingRequestClosingFactory)
    .factory('FRDisbursementsFactory', FundingRequestDisbursementsFactory)
    .factory('FRDocumentsFactory', FundingRequestDocumentsFactory)
    .factory('FRInformationFactory', FundingRequestInformationFactory)
    .run(($templateCache) => {
        $templateCache.put('app/appDetail/appDetail.html', require('./appDetail.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/appDetail/index.js